import { Link } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';
import { ThemePicker, ThemeToggle } from '@kss/ui';

export function WebFooter() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="border-t border-[var(--color-border)] bg-[var(--color-bg-topbar)]">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-12">
        <div className="mb-6 flex flex-wrap items-start justify-between gap-4 sm:mb-8">
          <div>
            <div className="flex items-center gap-2 text-lg font-bold text-[var(--color-text-primary)]">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-[var(--color-primary)] text-white">
                K
              </span>
              KSS
            </div>
            <p className="mt-2 text-sm text-[var(--color-text-secondary)]">
              Modular admin platform for modern teams.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <ThemePicker />
            <ThemeToggle />
            <button
              type="button"
              aria-label="Scroll to top"
              onClick={scrollTop}
              className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-[var(--color-border)] bg-[var(--color-bg-card)] text-[var(--color-text-primary)] hover:bg-[var(--color-bg-card-hover)]"
            >
              <ArrowUp className="h-4 w-4" />
            </button>
          </div>
        </div>

        {/* Three columns sit side-by-side on every viewport — even
            phones, where the link counts (3 / 2 / 2) are short
            enough to read in narrow columns. The previous
            `grid-cols-1 sm:grid-cols-3` dropped to a single stacked
            column on phones, which made the footer feel as tall as
            the page above it. */}
        <div className="grid grid-cols-3 gap-3 sm:gap-6">
          <div className="min-w-0">
            <div className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-[var(--color-text-muted)] sm:mb-3 sm:text-xs">
              Product
            </div>
            <ul className="space-y-1.5 text-xs text-[var(--color-text-secondary)] sm:space-y-2 sm:text-sm">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/demo">Demo</Link></li>
              <li><Link to="/panel/components">Components</Link></li>
            </ul>
          </div>
          <div className="min-w-0">
            <div className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-[var(--color-text-muted)] sm:mb-3 sm:text-xs">
              Company
            </div>
            <ul className="space-y-1.5 text-xs text-[var(--color-text-secondary)] sm:space-y-2 sm:text-sm">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="min-w-0">
            <div className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-[var(--color-text-muted)] sm:mb-3 sm:text-xs">
              Account
            </div>
            <ul className="space-y-1.5 text-xs text-[var(--color-text-secondary)] sm:space-y-2 sm:text-sm">
              <li><Link to="/login">Log in</Link></li>
              <li><Link to="/panel">Panel</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-[var(--color-border)] py-4 text-center text-xs text-[var(--color-text-muted)]">
        © {new Date().getFullYear()} KSS. All rights reserved.
      </div>
    </footer>
  );
}

export default WebFooter;
